<div class="flex-grow-1 bg-image">
  @if (!loading) {
    <nz-page-header title="Общи условия"/>
    <div class="container-lg">
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <main class="p-3">
          <p>
            Този документ определя условията и правилата за използване на предоставяните услуги, достъпни чрез сайта
            <strong>collectoria.bg</strong>, който се администрира от <strong>„Нумизмат“ ЕООД</strong>.
          </p>
          <p class="m-0">
            Сайтът collectoria.bg представлява платформа за онлайн търговия, предоставяща чисто съдържание, като не
            използва бисквитки и реклами. В рамките
            на тази платформа потребителите имат възможност да:
          </p>
          <ul>
            <li>
              публикуват обяви за продажба на продукт/стока на фиксирана цена или чрез онлайн търг;
            </li>
            <li>
              участват безплатно в онлайн наддавания на онлайн търгове, публикувани от други потребители;
            </li>
            <li>
              купуват продукт/стока, публикувани от друг потребител;
            </li>
          </ul>
          <div class="fs-6 fw-medium">
            Термини:
          </div>
          <ul class="mb-0">
            <li>
              онлайн търг/аукцион – това е уеб обява за продажба, с наддаване, която се осъществява през сайта
              collectoria.bg;
            </li>
            <li>
              потребител – всяко лице, регистрирано в платформата, което използва даден продукт, услуга или ресурс на
              сайта;
            </li>
            <li>
              продавач – всяко лице, което предлага своите стоки или услуги за продажба на фиксирана цена или онлайн
              търг/аукцион на други лица,
              наречени
              купувачи;
            </li>
            <li>
              купувач – всяко лице, което придобива стока или услуга от продавач в замяна на заплащане;
            </li>
            <li>
              сделка – споразумение между продавач и купувач за извършване на покупко-продажба на стоки или услуги,
              включително спечелване на онлайн
              търг/аукцион;
            </li>
            <li>
              потребителска сметка/потрфейл – индивидуална виртуална сметка на база разпределени в нея единици,
              показваща всички начислени суми от и към
              collectoria.bg за използване на функционалностите на платформата. Това <strong>НЕ СА</strong> електронни
              пари, сметката не притежава
              разплащателна функция между страните по осъществени сделки (Продавач-Купувач);
            </li>
            <li>
              рейтинг – индикатор за активността и доверието към потребителя в платформата. Той се базира на извършените
              действия и отзивите от други
              потребители.
            </li>
            <li>
              запазена цена - цена, под която продавачът не е съгласен на сделка;
            </li>
            <li>
              купи сега цена - цена, при която продавачът е съгласен на сделка и без наддаване.
            </li>
          </ul>
        </main>
      </section>

      <!--  I. ОБЩИ ПОЛОЖЕНИЯ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">I. ОБЩИ ПОЛОЖЕНИЯ</h5>
        </header>
        <main class="p-3">
          <p class="mb-2">
            <strong>Чл. 1. </strong>(1) Настоящите общи условия уреждат взаимоотношенията между „Нумизмат“ ЕООД, ЕИК:
            207489535, със седалище и адрес на
            управление – гр. София, наричано занапред Нумизмат, от една страна, и лицата – получатели на услугите на
            информационно общество по смисъла
            на
            ЗЕТ, наричани занапред потребители.
          </p>
          <p class="mb-2">
            (2) Настоящите общи условия уреждат и реда за подаване и разглеждане на сигнали за нарушаващи обяви и
            последиците при установяването на
            такива.
          </p>
          <p>
            (3) Настоящите общи условия не уреждат взаимоотношенията между потребителите.
          </p>
          <p>
            <strong>Чл. 2. </strong>Необходимо е всяко лице, желаещо да използва услугите на Нумизмат, да направи
            регистрация.
          </p>
          <p>
            <strong>Чл. 3. </strong>Право на регистрация имат само пълнолетни физически лица, навършили 18 години.
          </p>
          <p>
            <strong>Чл. 4. </strong>С регистрацията си в платформата всяко лице задължително се съгласява с настоящите
            общи условия и декларира, че ще
            ги
            спазва.
          </p>
          <p class="m-0">
            <strong>Чл. 5. </strong>С приемането на общите условия, потребителите дават съгласието си да получават
            търговски съобщения, свързани с
            предоставяните услуги от Нумизмат.
          </p>
        </main>
      </section>

      <!--  II. ЛИЧНИ ДАННИ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">II. ЛИЧНИ ДАННИ</h5>
        </header>
        <main class="p-3">
          <p>
            <strong>Чл. 6. </strong>Нумизмат полага дължимата грижа за защита на личните данни на потребителя, при
            стриктно спазване разпоредбите на
            ЗЗЛД,
            Европейския регламент (ЕС) 2016/679 на Европейския парламент и на Съвета от 27 април 2016 г., по-известен
            като GDPR, и приложимото
            законодателство в областта на защитата на лични данни, както и на утвърдената от Нумизмат Политика за защита
            на личните данни.
          </p>
          <p>
            <strong>Чл. 7. </strong>Регистрацията, включително свързаните с нея данни (като рейтинг), както и
            произтичащите задължения към сайта, е
            персонална и не може да бъде прехвърляна на други лица.
          </p>
          <p class="m-0">
            <strong>Чл. 8. </strong>Уебсайтът не носи отговорност, когато е оповестена лична информация на потребители в
            описанията на обяви от типа с
            фиксирана цена и онлайн търгове.
          </p>
        </main>
      </section>

      <!--  III. ТАКСИ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">III. ТАКСИ</h5>
        </header>
        <main class="p-3">
          <p>
            <strong>Чл. 9. </strong>Регистрацията за всички потребители на сайта е напълно безплатна.
          </p>
          <p>
            <strong>Чл. 10. </strong>На купувачите не се начисляват никакви такси.
          </p>
          <p>
            <strong>Чл. 11. </strong>На продавачите, използващи сайта, се начисляват такси само при осъществяване на
            сделка с купувач.
          </p>
          <p>
            <strong>Чл. 12. </strong>Начислените на продавача такси са с включено ДДС.
          </p>
          <p>
            <strong>Чл. 13. </strong>При осъществяване на сделка във всички категории при обяви с фиксирана цена се
            начислява крайна такса в размер на
            <strong>{{ paymentSettings.fixedPriceCommission.toFixed(2) }}%</strong> от крайната цена, но не повече от
            <strong> {{ paymentSettings.maxCommission.toFixed(2) }} лева</strong> и не по-малко от
            <strong>{{ paymentSettings.minCommission.toFixed(2) }} лева</strong>.
          </p>
          <p>
            <strong>Чл. 14. </strong>При осъществяване на сделка във всички категории при обяви от типа онлайн търг се
            начислява крайна такса в размер
            на
            <strong>{{ paymentSettings.auctionCommission.toFixed(2) }}%</strong> от крайната цена, но не повече от
            <strong> {{ paymentSettings.maxCommission.toFixed(2) }} лева</strong> и не по-малко от
            <strong>{{ paymentSettings.minCommission.toFixed(2) }} лева</strong>.
          </p>
          <p>
            <strong>Чл. 15. </strong>При неосъществена сделка продавачът може да подаде заявка за възстановяване на
            таксата чрез посочените на сайта
            контакти или чрез формата за контакт.
          </p>
          <p>
            <strong>Чл. 16. </strong>Заявки за възстановяване на такси могат да се подават не по-рано от 10 дни и не
            по-късно от 25 дни след приключване
            на обявата и при липса на информация за доставена пратка.
          </p>
          <p>
            <strong>Чл. 17. </strong>Подадените заявки за възстановяване на такси се обработват в рамките на 5
            календарни дни.
          </p>
          <p class="mb-2">
            <strong>Чл. 18. </strong>(1) Зареждането на потребителска сметка се осъществява чрез депозиране на средства
            по сметка на „Нумизмат“ ЕООД.
            Сайтът отразява внесената сума в единици, равни на платената стойност. Тази стойност се актуализира след
            всяка операция, която променя
            баланса
            (зареждането увеличава сумата в сметката, а начисляването на такса я намалява).
          </p>
          <p class="mb-2">
            (2) Зареждането на потребителска сметка може да се извършва по всяко време с произволна сума, но не по-малка
            от 1 лев.
          </p>
          <p class="mb-2">
            (3) В случай на отрицателен баланс по конкретна потребителска сметка в края на текущия месец, по-малък от
            минус 5 лева, потребителят е
            длъжен
            да зареди сметката си с достатъчна сума, за да погаси текущото си задължение, но не по-късно от 10-то число
            на следващия месец.
          </p>
          <p class="mb-0">
            (4) При просрочване на срока по ал. 3 ще бъдат наложени ограничения на профила. Ако потребителят има
            допълнителни профили или има
            доказателства за свързаност с други профили, ограниченията ще важат за всички свързани профили. За
            премахването на ограниченията е
            необходимо
            пълно погасяване на задължението към Нумизмат.
          </p>
        </main>
      </section>

      <!--  IV. ПУБЛИКУВАНЕ НА ОБЯВИ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">IV. ПУБЛИКУВАНЕ НА ОБЯВИ</h5>
        </header>
        <main class="p-3">
          <p class="mb-2">
            <strong>Чл. 19. </strong>(1) Публикуваните обяви ще бъдат активни и видими за другите потребители в периода
            от началната до крайната дата на
            обявата.
          </p>
          <p class="mb-2">
            (2) Началната и крайната дата се определят от потребителя при създаването на обявата и не могат да бъдат
            променяни след това.
          </p>
          <p class="m-0">
            (3) Максималният период, през който обявата ще бъде активна и видима за другите потребители е 6 месеца.
          </p>
        </main>
      </section>

      <!--  V. ИЗИСКВАНИЯ КЪМ ОБЯВИТЕ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">V. ИЗИСКВАНИЯ КЪМ ОБЯВИТЕ</h5>
        </header>
        <main class="p-3">
          <p class="mb-2">
            <strong>Чл. 20. </strong>(1) Всяка обява следва да има заглавие и прикачена поне една снимка, които точно и
            ясно описват продукта/стоката,
            която се предлага.
          </p>
          <p class="mb-2">
            (2) Всяка обява следва да има категория и подкатегория, които ясно и конкретно са свързани с нея.
          </p>
          <p class="mb-2">
            (3) Всяка обява следва да има начална и крайна дата, която обхваща периода, в който обявата ще бъде активна
            и видима за потребителите.
          </p>
          <p>
            (4) Всяка обява следва да има посочено населено място.
          </p>
          <p>
            <strong>Чл. 21. </strong>В обява с фиксирана цена трябва да бъде посочена крайната цена на продукта или
            стоката.
          </p>
          <p class="mb-2">
            <strong>Чл. 22. </strong>(1) В обява за онлайн търг трябва да бъде посочена ясно началната цена и
            минималната стъпка за наддаване.
          </p>
          <p class="mb-2">
            (2) Допуска се онлайн търгът да има и фиксирана цена („Купи сега“).
          </p>
          <p class="mb-2">
            (3) Допуска се онлайн търгът да има запазена цена. Ако наддаването не премине тази цена, сделката не се
            осъществява.
          </p>
          <p class="mb-2">
            (4) Допуска се онлайн търгът да бъде удължаван с 1, 2 или 5 минути, в зависимост от избора на продавача.
          </p>
          <p>
            (5) Всички наддавания са публични и видими за всички потребители в сайта.
          </p>
          <p>
            <strong>Чл. 23. </strong>Когато предмет на обявата са стоки, пакетирани или опаковани предварително, тя
            трябва да съдържа информация за
            тяхното количество.
          </p>
          <p>
            <strong>Чл. 24. </strong>Обявата не може да представлява забранена от Закона за защита на потребителите
            нелоялна търговска практика.
          </p>
          <p>
            <strong>Чл. 25. </strong>Обявата може да има за предмет само безопасни стоки и услуги по смисъла на Закона
            за защита на потребителите.
          </p>
          <p class="mb-1">
            <strong>Чл. 26. </strong>Всеки потребител може да публикува обява за продажба на продукта/стоката, след като
            са спазени следните условия:
          </p>
          <ul>
            <li>
              стоката не е забранена от Българското или Европейското законодателство;
            </li>
            <li>
              продавачът притежава всички необходими лицензи, разрешителни и патенти, в случай че се изискват от
              Българското или Европейското
              законодателство;
            </li>
            <li>
              продуктът/стоката е представена чрез текст и/или изображения по начин непредизвикващ объркване в
              купувачите;
            </li>
            <li>
              в случай, когато продуктът/стоката е от вида „Реплика“, това трябва да е декларирано както в описанието,
              така и в заглавието на обявата;
            </li>
            <li>
              основното изображение визуализира обявения за продажба продукт/стока;
            </li>
          </ul>
          <p class="mb-1">
            <strong>Чл. 27. </strong>Забранено е публикуването на обяви за продукти/стоки или услуги, включително, но не
            само:
          </p>
          <ul>
            <li>
              които съдържат лични данни;
            </li>
            <li>
              които съдържат рекламни линкове;
            </li>
            <li>
              които нарушават правата на трети лица върху обекти на интелектуалната и индустриалната собственост;
            </li>
            <li>
              които съдържат вулгарни или противоречащи на добрите нрави думи и изрази;
            </li>
            <li>
              които съдържат изображения с агресивни сцени, противоречащи на добрите нрави (вкл. сцени на насилие,
              садизъм, детска порнография);
            </li>
            <li>
              които са свързани с услуги от сексуален характер, в това число видео и телефонни сеанси, секс чатове,
              посещения на адреси, еротични
              масажи,
              на порнографски материали, секс артикули, медикаменти, лубриканти и други;
            </li>
          </ul>
          <p>
            <strong>Чл. 28. </strong>Продавачът няма право да иска от купувача допълнителни такси, надценки, ДДС и други
            доплащания, при положение че не
            са описани изрично в обявата.
          </p>
          <p class="m-0">
            <strong>Чл. 29. </strong>Нумизмат си запазва правото да анулира без предизвестие всяка обява, както и да
            премахва текст или част от текст,
            публикуван от потребител и публично визуализиран в съдържанието на сайта.
          </p>
        </main>
      </section>

      <!--  VI. НАРУШАВАЩИ ОБЯВИ, СИГНАЛИ И РЕД ЗА РАЗГЛЕЖДАНЕТО ИМ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">VI. НАРУШАВАЩИ ОБЯВИ, СИГНАЛИ И РЕД ЗА РАЗГЛЕЖДАНЕТО ИМ</h5>
        </header>
        <main class="p-3">
          <p>
            <strong>Чл. 30. </strong>Всички обяви, които нарушават нормативни забрани или клаузи от тези общи условия,
            ще бъдат считани за нарушения и
            ще
            бъдат премахвани от сайта незабавно след получаване на сигнал или служебно от Нумизмат.
          </p>
          <p>
            <strong>Чл. 31. </strong>Всяко лице може да подаде сигнал за нарушаващата обява, като използва електронната
            форма на сайта „Контакт с
            нас“ или посочените контакти. След получаване на сигнала, Нумизмат в срок от 24 часа извършва проверка и ако
            го намери за основателен,
            премахва нарушаващата обява.
          </p>
        </main>
      </section>

      <!--  VII. ПОТРЕБИТЕЛСКИ РЕЙТИНГ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">VII. ПОТРЕБИТЕЛСКИ РЕЙТИНГ</h5>
        </header>
        <main class="p-3">
          <p class="mb-2">
            <strong>Чл. 32. </strong>(1) Всеки регистриран потребител в платформата има личен рейтинг, който отразява
            активността му и доверието към
            него
            от страна на останалите потребители. Рейтингът се формира въз основа на извършените действия и отзивите от
            други потребители.
          </p>
          <p class="mb-1">
            (2) Потребителският рейтинг има цифрово отражение и може да се увеличава или намалява в следните случаи:
          </p>
          <ul>
            <li>
              <strong>-10 </strong>за получен отзив с оценка 0%.
            </li>
            <li>
              <strong>-5 </strong>за получен отзив с оценка 25%.
            </li>
            <li>
              <strong>+5 </strong>за получен отзив с оценка 75%.
            </li>
            <li>
              <strong>+10 </strong>за получен отзив с оценка 100%.
            </li>
            <li>
              <strong>+1 </strong>за всяка добавена нова обява;
            </li>
            <li>
              <strong>+2 </strong>за всяка продажба или покупка;
            </li>
          </ul>
          <table class="mb-0 table table-striped table-hover">
            <thead class="text-start">
            <tr>
              <th scope="col">Маркер</th>
              <th scope="col">Рейтинг</th>
            </tr>
            </thead>
            <tbody class="text-start">
            <tr>
              <th class="fw-normal" scope="row">Няма</th>
              <td>Под 0</td>
            </tr>
            <tr>
              <th scope="row"><i class="fa-solid fa-star text-muted"></i></th>
              <td>0 - 9</td>
            </tr>
            <tr>
              <th scope="row"><i class="fa-solid fa-star nz-color-star"></i></th>
              <td>10 - 49</td>
            </tr>
            <tr>
              <th scope="row">
                <i class="fa-solid fa-star nz-color-star"></i>
                <i class="fa-solid fa-star nz-color-star"></i>
              </th>
              <td>50 - 199</td>
            </tr>
            <tr>
              <th scope="row">
                <i class="fa-solid fa-star nz-color-star"></i>
                <i class="fa-solid fa-star nz-color-star"></i>
                <i class="fa-solid fa-star nz-color-star"></i>
              </th>
              <td>200 - 499</td>
            </tr>
            <tr>
              <th scope="row"><i class="fa-solid fa-gem nz-color-gem"></i></th>
              <td>500 - 999</td>
            </tr>
            <tr>
              <th scope="row">
                <i class="fa-solid fa-gem nz-color-gem"></i>
                <i class="fa-solid fa-gem nz-color-gem"></i>
              </th>
              <td>1000 - 2499</td>
            </tr>
            <tr>
              <th scope="row">
                <i class="fa-solid fa-gem nz-color-gem"></i>
                <i class="fa-solid fa-gem nz-color-gem"></i>
                <i class="fa-solid fa-gem nz-color-gem"></i>
              </th>
              <td>2500 - 4999</td>
            </tr>
            <tr>
              <th scope="row"><i class="fa-solid fa-crown nz-color-crown"></i></th>
              <td>5000 - 9999</td>
            </tr>
            <tr>
              <th scope="row">
                <i class="fa-solid fa-crown nz-color-crown"></i>
                <i class="fa-solid fa-crown nz-color-crown"></i>
              </th>
              <td>10000 - 19999</td>
            </tr>
            <tr>
              <th scope="row">
                <i class="fa-solid fa-crown nz-color-crown"></i>
                <i class="fa-solid fa-crown nz-color-crown"></i>
                <i class="fa-solid fa-crown nz-color-crown"></i>
              </th>
              <td>Над 19999</td>
            </tr>
            </tbody>
          </table>
        </main>
      </section>

      <!--  VIII. ОТГОВОРНОСТИ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">VIII. ОТГОВОРНОСТИ</h5>
        </header>
        <main class="p-3">
          <p>
            <strong>Чл. 33. </strong>Нумизмат не носи отговорност за съдържанието, верността и актуалността на
            публикуваните обяви. Отговорност за това
            носят авторите на обявите.
          </p>
          <p class="mb-1">
            <strong>Чл. 34. </strong>Нумизмат се задължава да не разкрива никакви лични данни за потребителите на трети
            лица – държавни органи,
            търговски
            дружества, физически лица и други, освен в случаите, когато:
          </p>
          <ul class="mb-0">
            <li>
              е получено изричното съгласие от потребителя;
            </li>
            <li>
              информацията е изискана от държавни органи или длъжностни лица, които според действащото законодателство
              са оправомощени да изискват и
              събират такава информация;
            </li>
            <li>
              Нумизмат е длъжно да предостави информацията по силата на закона;
            </li>
          </ul>
        </main>
      </section>

      <!--  IX. ИНТЕЛЕКТУАЛНА СОБСТВЕНОСТ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">IX. ИНТЕЛЕКТУАЛНА СОБСТВЕНОСТ</h5>
        </header>
        <main class="p-3">
          <p class="mb-0">
            <strong>Чл. 35. </strong>Сайтът collectoria.bg, като софтуерен продукт, дизайн и съдържание, е обект на
            интелектуална и индустриална
            собственост
            на „Нумизмат“ ЕООД.
          </p>
        </main>
      </section>

      <!--  IIX. ЗАКЛЮЧИТЕЛНИ РАЗПОРЕДБИ-->
      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
          <h5 class="m-0 fs-6">IIX. ЗАКЛЮЧИТЕЛНИ РАЗПОРЕДБИ</h5>
        </header>
        <main class="p-3">
          <p>
            <strong>Чл. 36. </strong>Настоящите общи условия са публикувани на адрес: collectoria.bg и могат да бъдат
            едностранно изменяни от Нумизмат, като измененията влизат в сила с публикуването им на посочения адрес.
          </p>
          <p>
            <strong>Чл. 37. </strong>Нумизмат не е посредник, не участва и не носи отговорност по никакъв начин за
            сделките, които се сключват между
            купувачи и продавачи.
          </p>
          <p class="mb-0">
            <strong>Чл. 38. </strong>За всички неуредени в настоящите общи условия случаи се прилагат разпоредбите на
            действащото в Република България
            законодателство.
          </p>
        </main>
      </section>

      <section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
        <main class="p-3">
          Настоящите общи условия са актуални към дата <strong>21.03.2025 г.</strong> и отменят всички предходни.
        </main>
      </section>
    </div>
  } @else {
    <nz-loader/>
  }
</div>
